import { Directive, ElementRef, Renderer2, HostListener, Input } from '@angular/core';
import { parse } from 'node:path';

@Directive({
  selector: '[limiter]' // Attribute selector
})
export class LimiterDirective  {

  @HostListener('keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    if(this.maxValue === undefined) this.updateWarning(this.el.nativeElement.value.length);
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    let curr = this.el.nativeElement.value;
    curr = event.key === 'Backspace' ?curr.slice(0, -1) : curr + '' + event.key;
    curr = parseFloat(curr);
    if(this.maxValue !== undefined) this.updateWarning(curr, true);
  }
  @Input() limiter?: number | '' = 1000;
  @Input() maxValue?: number = undefined;
  warningDiv!: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    this.warningDiv = this.renderer.createElement('div');
    this.renderer.setStyle(this.warningDiv, 'color', 'red');
    this.renderer.setStyle(this.warningDiv, 'fontSize', '12px');
    this.renderer.setStyle(this.warningDiv, 'position', 'absolute');
    this.renderer.setStyle(this.warningDiv, 'bottom', '5px');
    this.renderer.setStyle(this.warningDiv, 'right', '-0px');
    
    const parent = this.el.nativeElement.parentNode;
    this.renderer.setStyle(parent, 'position', 'relative');
    this.renderer.appendChild(parent, this.warningDiv);
    this.el.nativeElement.maxLength = this.limiter; // Example: limit to 10 characters
    if(this.maxValue !== undefined) this.el.nativeElement.max = this.maxValue;
    const limitValue = this.maxValue !== undefined;
    const curr = limitValue ? parseFloat(this.el.nativeElement.value) : this.el.nativeElement.value.length;
    this.updateWarning(curr, limitValue);
  }
  
  private updateWarning(curr: number, limitValue = false) {
    if(limitValue && this.maxValue === undefined) return;
    const value = this.el.nativeElement.value;
    const max = limitValue && this.maxValue !== undefined ? this.maxValue : parseFloat(this.limiter + '');
    curr = limitValue ? curr : value.length;
    const percentage = (curr / max) * 100;
    if(limitValue){
      this.warningDiv.innerText = curr > max ? `value limit exceeded: ${max}` : '';
    }else{
      this.warningDiv.innerText = percentage > 50 ? `${curr} / ${max}` : '';
      if(percentage > 80){
        this.warningDiv.classList.remove('opacity-50');
      } else {
        this.warningDiv.classList.add('opacity-50');
      }
    }
  }
}